<script lang="ts">
export default {
  name: 'CompaniesSnsInstagramHashtagList',
}
</script>
<script setup lang="ts">
import { computed, ref } from 'vue'
import { useStore } from 'vuex'
import { useI18n } from 'vue-i18n'
import {
  KkLoading,
  KkButton
} from '../../../../components/base'
import { KkInfo } from '../../../../components/ui'
import { KkTutorial } from '../../../../components/projects'
import {
  KkHashtagContainer
} from '../../../../components/domains/sns'
import tutorialImgPath from '../../../../../../images/sns/instagramHashtag/tutorial.png'
import type { Account } from '../../../../components/domains/sns/types'

const store = useStore()
const { t } = useI18n()

const instagramBusinessAccounts = computed<Account[]>(() => store.getters['companiesSnsInstagramBusinessAccounts/instagramBusinessAccounts'])
const instagramBusinessAccountsLoading = computed<boolean>(() => store.getters['companiesSnsInstagramBusinessAccounts/loading'])

const readInstagramBusinessAccounts = (): Promise<void> => store.dispatch('companiesSnsInstagramBusinessAccounts/readInstagramBusinessAccounts')

const hasLookedTutorial = ref<boolean>(false)

const noSetting = computed<boolean>(() => {
  for (let account of instagramBusinessAccounts.value) {
    if (account.stores.length || account.hashTags.length) return false
  }
  return true
})
// アカウントにハッシュタグも店舗も設定されていない && チュートリアルを見ていない
const showTutorial = computed<boolean>(() => noSetting.value && !hasLookedTutorial.value)

const showOnlyOwnerAuthority = computed<boolean>(() => store.getters['companiesAccessibleApi/showOnlyOwnerAuthority'])

const loading = computed<boolean>(() => instagramBusinessAccountsLoading.value)

const load = (): void => {
  readInstagramBusinessAccounts()
}
load()
</script>
<template>
  <KkLoading v-if="loading" />
  <div v-else-if="showTutorial" class="p-box">
    <KkTutorial
      :description1="t('pages.companies.instagramHashtag.list.noSetting.notice')"
      :img-path="tutorialImgPath"
      :tutorial-description="t('pages.companies.instagramHashtag.list.noSetting.description')"
    >
      <template v-if="showOnlyOwnerAuthority" #buttonArea>
        <KkButton
          color="primary"
          :text="t('pages.companies.instagramHashtag.list.noSetting.connect')"
          @click="hasLookedTutorial = true"
        />
      </template>
    </KkTutorial>
  </div>
  <div v-else class="p-box">
    <div class="p-box__body">
      <KkInfo>
        {{ t('pages.companies.instagramHashtag.list.info') }}
      </KkInfo>
      <div class="p-table__content">
        <table>
          <thead>
            <tr>
              <th style="width: 25%;">
                {{ t('pages.companies.instagramHashtag.list.table.header.account') }}
              </th>
              <th>
                {{ t('pages.companies.instagramHashtag.list.table.header.hashtag') }}
              </th>
              <th style="width: 10%;">
                {{ t('pages.companies.instagramHashtag.list.table.header.stores') }}
              </th>
              <th style="width: 15%;" />
            </tr>
            <tr class="p-table__content__space"><td colspan="5" /></tr>
          </thead>
          <tbody>
            <KkHashtagContainer v-for="(account, i) in instagramBusinessAccounts" :key="i" :account="account" />
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "../../../../../../stylesheets/biz_spa/foundation/var";
.info {
  margin-bottom: 30px;
}
</style>
